export const httpPreffixStrategy = href => href.search('https?://') >= 0 ? href : `http://${href}`
export const hasLinks = state => state.inlines.some(inline => inline.type === 'link')
export const getLink = state => state.inlines.filter(inline => inline.type === 'link').first()
export const createLink = data => ({ type: 'link', data })
export const hasMultiBlocks = state => state.blocks.size > 1

export const unlink = state =>
  state
    .transform()
    .unwrapInline('link')
    .apply()

export const updateLinkStrategy = ({ state, data }) => {
  let transform = state.transform()
  let text = data.text

  if (state.isCollapsed) {
    transform
      .moveOffsetsTo(0, state.anchorText.characters.size)
  }

  transform
    .insertText(text)
    .extend(text.length * -1)
    .setInline({
      type: 'link',
      data
    })
    .moveOffsetsTo(1, 1)

  return transform.apply()
}

export const insertLinkStrategy = ({state, customData = {}}) => {
  let transform = state.transform()

  if (hasLinks(state)) {
    transform.unwrapInline('link')
  } else if (state.isExpanded && !hasMultiBlocks(state)) {
    const startOffset = state.selection.startOffset
    const endOffset = state.selection.endOffset

    const selectedText = state.anchorText.text.substring(startOffset, endOffset)

    // Full explanation of issue:
    // https://github.com/nossas/slate-editor/issues/42#issuecomment-332976912
    // If the selected text is either at the beginning of a line or immediately
    // after an inline node (ie startOffset === 0 then insert
    // the selected text and with a space before it before wrapping the
    // text with an inline link.
    if (startOffset === 0) {
      const space = ' '
      transform
        .insertText(space + selectedText)
        .moveOffsetsTo(space.length, selectedText.length + space.length)
    }

    const data = {
      isInternalLink: true,
      openModal: true,
      title: selectedText,
      ...customData
    }

    transform
      .wrapInline(createLink(data))

    // fix offset 0 selection:
    // remove the white space added before
    if (startOffset === 0) {
      transform
        .moveOffsetsTo(0, 0)
        .deleteBackward()
    }
  } else if (hasMultiBlocks(state)) {
    console.info('[SlateJS][LinkPlugin] has multiple blocks on selection')
  } else if (state.isCollapsed && !hasLinks(state)) {
    console.info('[SlateJS][LinkPlugin] selection collapsed, w/o links on selection')
  }

  return transform.apply()
}



// WEBPACK FOOTER //
// ./src/components/LinkSlatePlugin/LinkUtils.js